import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {  Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../Components/Button/CustomButton";
import { handleAddPolicy } from "../../../APIs/Function/Policy/AddPolicy";
import { GetPolicy } from "../../../APIs/Function/Policy/GetPolicy";
import { GetAbout } from "../../../APIs/Function/About/GetAbout";
import { handleAddAboutUs } from "../../../APIs/Function/About/AddAbout";

const AboutUs = () => {
  const [loading, setLoading] = useState(false);

  const handleDragStart = (event) => {
    event.preventDefault();
  };
  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "list",
    "bullet",
    "link",
  ];
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      policy: "",
    },
    validationSchema: Yup.object({
      policy: Yup.string().required("Policy Is Required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        let res = await handleAddAboutUs(values);
        if (res.s) {
         alert("About us Updated Successfully")
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    },
  });


  const handlePolicy = async () => {
    try {
      let res = await GetAbout();
      if (res.s) {
        console.log(res.r.about_us);
        formik.setFieldValue("policy", res.r.about_us);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlePolicy();
  }, []);

  return (
    <Box>


      <Box
        sx={{
          width: "95%",
          m: "auto",
          textAlign: "left",
          borderRadius: "10px",
          boxSizing: "border-box",
          p: "2px",
          mt: "15px",
          "& .ql-container": {
            minHeight: "200px",
            maxHeight: "80vh",
            overflow: "auto",
            resize: "both",
            backgroundColor: "transparent",
            color: "#000",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            // border: "none",
            backgroundColor: "#fff",
          },
          "& .ql-toolbar": {
            // borderTop: "none",
            // borderLeft: "none",
            // borderRight: "none",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            zIndex: 999,
            backgroundColor: "#fff",
          },
        }}
      >
        <ReactQuill
          name="policy"
          style={{
            width: "100%",
            textAlign: "left",
            borderRadius: "15px",
          }}
          formats={formats}
          onDragStart={handleDragStart}
          theme="snow"
          onChange={(e) => {
            formik.setFieldValue("policy", e);
          }}
          value={formik.values.policy}
          modules={{
            toolbar: {
              container: [
                [{ header: "1" }, { header: "2" }],
                [{ font: [] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                ["clean"],
              ],
            },
          }}
        />
      </Box>

      <Box
        sx={{
          width: "97%",
          display: "flex",
          justifyContent: "end",
          mt: "10px",
        }}
      >
        <CustomButton
          disabled={!(formik.dirty && formik.isValid)}
          onClick={formik.handleSubmit}
          sx={{
            width: "20%",
            "&:disabled": {
              color: "#fff",
              bgcolor: "gray",
            },
          }}
        >
          Submit
        </CustomButton>
      </Box>
    </Box>
  );
};

export default AboutUs;
